import { FC } from 'react';
import { ShopByTaxon, PromotionsProps, Styled } from '.';

const Promotions: FC<PromotionsProps> = ({
  promotedTaxons,
  size = 'small',
}) => {
  return (
    <Styled.PromotionsContainer $size={size}>
      {promotedTaxons.map(promotedTaxon => {
        return (
          <ShopByTaxon
            taxon={promotedTaxon}
            key={promotedTaxon.permalink}
            size={size}
          />
        );
      })}
    </Styled.PromotionsContainer>
  );
};

export default Promotions;
